import { motion } from 'framer-motion';

const AnimationStarBeam = () => {
  return (
    <div className="mb-[10px] flex flex-col items-center">
      <motion.div
        className="w-[1px] h-[107px] mb-[-20px]"
        style={{
          background:
            'linear-gradient(180deg, rgba(255,255,255,0) 0%, #FFF 50%, rgba(255,255,255,0) 100%)',
          backgroundSize: '100% 200%',
          backgroundRepeat: 'no-repeat'
        }}
        initial={{ backgroundPosition: 'center 200%' }}
        animate={{ backgroundPosition: 'center 0%' }}
        transition={{ delay: 0.3, duration: 0.6, ease: 'linear' }}
      />
      <img src="/assets/scene/beam_star.png" alt="" className="w-[27px] h-[34px]" />
    </div>
  );
};

export default AnimationStarBeam;
